// src/pages/AboutPage.js
import React from 'react';
import './AboutPage.css'; // Make sure to create this CSS file
import content from '../../config/content'; // Import the content from the config file

const AboutPage = () => {
    return (
        <div className="about-page">
            <section className="about-section">
                <div className="about-text">
                    <img src={require('../../assets/wlogo.png')} alt="Logo" className="about-logo" />
                    <h2>{content.aboutContentpg.whoWeAre.heading}</h2>
                    <p>{content.aboutContentpg.whoWeAre.text}</p>
                    <p>{content.aboutContent.closingText}</p>
                </div>
                <div className="about-image">
                    <img src={require('../../assets/who-we-are.jpg')} alt="Who We Are" />
                </div>
            </section>

            <section className="vision-section">
                <div className="vision-background">
                    <div className="vision-text">
                        <h2>{content.aboutContentpg.ourVision.heading}</h2>
                        <p>{content.aboutContentpg.ourVision.text}</p>
                    </div>
                </div>
            </section>

            <section className="mission-section">
                <div className="mission-image">
                    <img src={require('../../assets/our-mission.jpg')} alt="Our Mission" />
                </div>
                <div className="mission-text">
                    <h2>{content.aboutContentpg.ourMission.heading}</h2>
                    <p>{content.aboutContentpg.ourMission.text}</p>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
